import { User } from "@saleor/fragments/types/User";
import { masterFulfillmentListPath } from "@saleor/motherOrders/urls";
import { financeOrderListUrl } from "@saleor/reports/PayoutOrders/urls";
import { PermissionEnum, SmopUserTypeCode } from "@saleor/types/globalTypes";
import { stringify as stringifyQs } from "qs";

export const userBusinessDetailsPath = "/business-details";
export const contactUsPath = "/contact-us";

export const userHomepagePath = "/";
export const userLoginPath = "/login";
export const switchAccountPath = "/switch-account/";
export const chooseAccountPath = "/choose-account";

export const passwordResetPath = "/reset-password/";
export const passwordResetUrl = passwordResetPath;

export const passwordResetSuccessPath = "/reset-password/success/";
export const passwordResetSuccessUrl = passwordResetSuccessPath;

export const newPasswordPath = "/new-password/";
export const userOTPPath = "/otp/:id";
export const userSignupPath = "/signup";
export const mfaVerificationPage = "/mfa-verification-page";

interface UserTypePath {
  path: string;
  userTypes: SmopUserTypeCode[];
}

export const getUserTypeDefaultPath = (user: User): UserTypePath => {
  const userTypePaths: UserTypePath[] = [
    {
      path: financeOrderListUrl(),
      userTypes: [SmopUserTypeCode.FINANCE_SPECIALIST]
    },
    {
      path: "/payout/batch",
      userTypes: [
        SmopUserTypeCode.FINANCE_MANAGER,
        SmopUserTypeCode.FINANCE_TREASURY_1,
        SmopUserTypeCode.FINANCE_TREASURY_2
      ]
    }
  ];

  const defaultPath = userTypePaths.find(path =>
    path.userTypes.includes(user?.accessGroup?.smopUsertypeCode)
  );

  return defaultPath;
};

interface UserPermissionPath {
  path: string;
  permissions: PermissionEnum[];
}

export const getPermissionDefaultPath = (user: User): UserPermissionPath => {
  const userPermissionPaths: UserPermissionPath[] = [
    {
      path: masterFulfillmentListPath,
      permissions: [PermissionEnum.VIEW_MASTER_FULFILLMENT]
    }
  ];

  const userPermissionCodes =
    user?.userPermissions?.map(perm => perm.code) || [];

  const defaultPath = userPermissionPaths.find(path =>
    path.permissions.some(permission =>
      userPermissionCodes.includes(permission)
    )
  );

  return defaultPath;
};

export interface NewPasswordUrlQueryParams {
  email: string;
  token: string;
}
export const newPasswordUrl = (params?: NewPasswordUrlQueryParams) =>
  newPasswordPath + "?" + stringifyQs(params);
